import { useState, useEffect } from "react";
import TableTop from "../TableComponents/TableTop";
import { Table, TableBody } from "@mui/material";
import ActiveRequestsTableHead from "../TableHeads/ActiveRequestsTableHead";
import ActiveCarRequestTableRow from "../TableRows/ActiveCarRequestTableRow";
import { requestGetActiveRequests } from "../../../reduxStore/sagas/requests/userCars";

const ActiveRequestTableInAllRequestsPage = ({
    id
}) => {
    const [isTableShown, setIsTableShown] = useState(true);

    const [fetchedActiveCarRequestsData, setFetchedActiveCarRequestsData] = useState(null);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await requestGetActiveRequests(id);

                if (response) {
                    setFetchedActiveCarRequestsData(response.data);
                };

            }
            catch (error) {
                console.error(error);
            };
        };

        fetchData();
    }, [id]);


    if (!fetchedActiveCarRequestsData) {
        return null;
    };

    return (
        <div style={styles.mainContainer}>
            <TableTop
                title={"Aktivni zahtevi"}
                count={fetchedActiveCarRequestsData.count}
                open={isTableShown}
                setOpen={setIsTableShown}
            />

            {isTableShown && (
                <div style={styles.tablePaddingDiv}>
                    <div style={styles.tableBorderDiv}>
                        <Table>
                            <ActiveRequestsTableHead />

                            <TableBody>

                                {fetchedActiveCarRequestsData.rows.map((row, index) => (
                                    <ActiveCarRequestTableRow
                                        key={index}
                                        carRequest={row}
                                    />
                                ))}

                            </TableBody>

                        </Table>
                    </div>
                </div>
            )}

        </div>
    );
};


export default ActiveRequestTableInAllRequestsPage;

const styles = {
    mainContainer: {

    },
    tablePaddingDiv: {
        paddingInline: 30,
    },
    tableBorderDiv: {
        borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
        borderRight: "1px solid rgba(0, 0, 0, 0.12)"
    }
};